import {Component, h, Prop, State} from '@stencil/core';

@Component({
    tag: 'physiogroup-gender-disclaimer',
    styleUrl: 'physiogroup-gender-disclaimer.scss',
    shadow: true,
})
export class PhysiogroupGenderDisclaimer {
    @Prop() language: string;

    @State() visible: boolean = false;

    cookieName: string = 'genderDisclaimerRead';

    componentDidLoad() {
        setTimeout(() => {
            if (this.getCookie(this.cookieName)) {
                return;
            }
            this.visible = true;
        });
    }

    setCookie(name: string, value: string | number, days = 182, hours = 0, minutes = 0) {
        let expires = "";

        const date = new Date();
        date.setTime(date.getTime() + (1000 * (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60)));
        expires = "; expires=" + date.toUTCString();

        if (location.protocol === "https:") {
            document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax; Secure";
        } else {
            document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
        }
    }

    getCookie(a) {
        return (a = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)")) ? a.pop() : ""
    }

    close() {
        this.setCookie(this.cookieName, 1);
        this.visible = false;
    }

    render() {
        return <div class={"gender-disclaimer-container " + (this.visible ? 'visible' : '')}>
            <div class="gender-disclaimer">
                <div class="close" onClick={() => this.close()}>✕</div>
                <slot/>
            </div>
        </div>;
    }
}
